import React from "react"
import ZdqConnectorSetup from "../../components/ZdqConnectorSetup"
import { SNOWFLAKE } from "../../Constants"

function ZdqSnowflakeConnector() {
    return <ZdqConnectorSetup vendor={SNOWFLAKE}></ZdqConnectorSetup>
}

export default ZdqSnowflakeConnector
